import { getLang } from '@translate';

export const getDateFormat = () => {
    const locale = getLang();
    return locale === 'cs-CZ' ? 'DD.MM.YYYY' : 'MM/DD/YYYY';
};

export const getDateTimeFormat = () => {
    const locale = getLang();
    return locale === 'cs-CZ' ? 'DD.MM.YYYY HH:mm' : 'MM/DD/YYYY HH:mm';
};

export const shortDateFormat = 'l';
